<template>
  <div class="shouye">
    <div class="head-title">参数配置</div>
    <div class="showInformation" :class="bianll == true ? 'gain' : 'no_gain'">
      <div class="showHeader">
        <p class="archiveTitle">存档参数配置</p>
        <div class="inforText">
          <p class="">还差一步就可以开始体验会话存档啦</p>
          <p class="">
            为保证正常体验会话内容存档全部功能，请先完成以下配置后使用，在配置过程中遇到问题可以联系客服400-113-0200
          </p>
        </div>
      </div>
      <div class="showContent">
        <div class="paramsInformation">
          <!-- form表单 -->
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-position="right"
              label-width="13rem"
              class="show-demo-ruleForm"
          >
            <!--            左1-->
            <div style="width: 49.5%;min-width: 75rem;position: relative">
              <div style="margin-bottom: 2rem;">
                <div class="mytitle">
                  <p class="title">配置企业全称</p>
                  <span
                      @click="onSubmit1 = true"
                  >配置教程</span>
                </div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开
                    <span style="color: #317AF8">我的企业</span>
                    ，将企业全称和ID分别复制并填写到下方输入框中

                  </p>
                  <el-form-item label="企业全称" prop="companyName" style="margin-bottom:1rem">
                    <el-input
                        clearable
                        v-model="ruleForm.companyName"
                        placeholder="请输入企业全称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="是否授权应用" prop="shouquan" style="height:4rem">
                    <!-- <img
                      v-if="shouquan == 0"
                      style="width: 10.0rem; height: 10.0rem"
                      :src="imgUrl"
                      alt=""
                    /> -->
                    <el-image
                        v-if="shouquan == 0"
                        style="width: 4rem; height: 4rem"
                        :src="imgUrl"
                        :preview-src-list="srcList"
                    >
                    </el-image>
                    <span v-else style="color: #49B372;margin-bottom: 0;font-size: 1.6rem;">已授权</span>
                  </el-form-item>
                  <el-form-item label="应用是否有权限" prop="authority">
                    <p style="color: #49B372;margin-bottom: 0">{{ authority }}</p>
                  </el-form-item>
                </div>
              </div>
              <div style="margin-bottom: 1.0rem;">
                <div class="mytitle">
                  <p class="title">配置可信IP地址</p><span
                    @click="onSubmit3 = true"
                >配置教程</span></div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【管理工具】
                    -进入【会话内容存档】-可信IP地址添加。将下方IP地址逐一复制并添加到企业微信-可信IP地址中

                  </p>
                  <div class="copyButton">
                    <el-form-item label="IP地址1">
                      <el-input
                          clearable
                          :readonly="true"
                          id="serverIp"
                          v-model="ipdz"
                          placeholder="服务器IP"
                      ></el-input>
                    </el-form-item>
                    <span class="copy" @click="copyValue('serverIp')">复制</span>
                  </div>
                </div>
              </div>
              <div style="margin-bottom: 2.0rem;">
                <div class="mytitle">
                  <p class="title">配置公钥版本号</p>
                  <span
                      @click="onSubmit5 = true"
                  >配置教程</span></div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【管理工具】 -进入【会话内容存档】
                    -消息加密公钥-版本号。将版本号复制并填写到下方输入框中，如果消息加密公钥有更新，请将更新后的版本号重新复制更新到下方输入框中

                  </p>
                  <div class="copyButton">
                    <el-form-item label="公钥版本号" prop="version">
                      <el-input
                          clearable
                          v-model="ruleForm.version"
                          placeholder="请输入消息加密公钥版本号"
                      ></el-input>
                    </el-form-item>
                    <!--                    <span class="copy" @click="copyValue('serverIp')">复制</span>-->
                  </div>
                </div>
              </div>
              <div style="margin-bottom: 2.0rem;">
                <div class="mytitle">
                  <p class="title">配置会话密钥Secret</p>
                  <span
                      @click="onSubmit6 = true"
                  >配置教程</span></div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【管理工具】 -进入【会话内容存档】 -Secret。
                    将会话Secret复制并填写到输入框中，如果会话Secret有更新，请将更新后的会话Secret重新复制更新到下方的输入框中

                  </p>
                  <div class="copyButton">
                    <el-form-item label="会话密钥Secret" prop="sessionKey">
                      <el-input
                          clearable
                          v-model="ruleForm.sessionKey"
                          placeholder="会话秘钥Secret"
                      ></el-input>
                    </el-form-item>
                    <!--                  <span class="copy" @click="copyValue('serverIp')">复制</span>-->
                  </div>
                </div>
              </div>
              <div>
                <div class="mytitle">
                  <p class="title">配置微信客服密钥Secret</p><span
                    @click="onSubmit10 = true"
                >配置教程</span></div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【应用管理】-下拉找到【微信客服】-开启并点击【通过API管理】-配置
                    接收事件服务器-获取Secret值并且配置到微炬云后台

                  </p>
                  <div class="copyButton">
                    <el-form-item
                        label="微信客服密钥Secret"
                        prop="service_secret"
                        label-width="17.0rem"
                    >
                      <el-input
                          clearable
                          v-model="ruleForm.service_secret"
                          placeholder="请输入微信客服密钥Secret"
                          id="weixinkefu"
                      ></el-input>
                    </el-form-item>
                    <span class="copy" @click="copyValue('weixinkefu')">复制</span></div>
                </div>
              </div>
            </div>
            <!-- <el-form-item label="企业ID" prop="account_corpid_ww">
              <el-input
                clearable
                v-model="ruleForm.account_corpid_ww"
                placeholder="请输入企业ID"
              ></el-input>
            </el-form-item> -->
            <!--            右1-->
            <div style="width: 49.5%;min-width: 75.0rem">
              <div style="margin-bottom: 2.0rem;height: 28.0rem">
                <div class="mytitle">
                  <p class="title">配置可见范围</p>
                  <span
                      @click="onSubmit2 = true"
                  >配置教程</span></div>
                <div class="mycontent">
                  <ul>
                    <li><img src="../../assets/qiyeweixin.png" alt="">
                      <p>进入企业微信</p></li>
                    <img class="jiantou" src="../../assets/箭头.png" alt="">
                    <li><img src="../../assets/管理工具.png" alt="">
                      <p>打开管理工具</p></li>
                    <img class="jiantou" src="../../assets/箭头.png" alt="">
                    <li><img src="../../assets/会话内容存档.png" alt="">
                      <p>点击进入<br>会话内容存档</p></li>
                    <img class="jiantou" src="../../assets/箭头.png" alt="">
                    <li><img src="../../assets/开启范围.png" alt="">
                      <p>开启范围<br>配置成员</p></li>
                    <img class="jiantou" src="../../assets/箭头.png" alt="">
                    <li><img src="../../assets/选择人员配置.png" alt="">
                      <p>选择人员配置</p></li>

                  </ul>
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【管理工具】 -进入【会话内容存档】
                    -开启范围，配置成员。设置后，可获取开启范围中成员的会话内容，必须在企业微信中配置完成，否则应用将无法获取会话内容

                  </p>
                </div>
              </div>
              <div style="margin-bottom: 2.0rem;height: 44rem;">
                <div class="mytitle">
                  <p class="title">配置消息加密公钥</p>
                  <span
                      @click="onSubmit4 = true"
                  >配置教程</span></div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【管理工具】-进入【会话内容存档】
                    -消息加密公钥-设置。将下方消息加密公钥信息复制并添加到企业微信-消息加密公钥-设置中如果在企业微信中已经设置过公钥信息，请点击下方【更新公钥】按钮进行公钥更新，并把最新的公钥信息复制并添加到企业微信-消息加密公钥-设置中

                  </p>
                  <div class="copyButton">
                    <el-form-item label="消息加密公钥" class="privateKey" style="margin:0 2.0rem 2.0rem 0">
                      <el-input
                          clearable
                          :readonly="true"
                          type="textarea"
                          style="z-index: 999"
                          id="privateKey"
                          placeholder="公钥内容"
                          v-model="publicContent"

                      ></el-input>
                    </el-form-item>
                    <div>
                      <el-button
                          type="primary"
                          icon="el-icon-refresh"
                          style="margin-bottom: 2.0rem"
                          @click="updatePublicKey"
                      >更新公钥
                      </el-button>
                      <span class="copy" @click="copyValue('privateKey')">复制</span>
                    </div>
                  </div>
                  <el-form-item label="消息加密私钥" class="messageEncryption">
                    <el-input
                        clearable
                        :readonly="true"
                        :placeholder="placeholderText"
                        v-model="privateContent"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div>
                <div class="mytitle">
                  <p class="title">配置客户密钥Secret</p>
                  <span
                      @click="onSubmit7 = true"
                  >配置教程</span></div>
                <div class="mycontent">
                  <p class="inwx">
                    进入
                    <a
                        class="help-link"
                        href="https://work.weixin.qq.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: #317AF8"
                    >企业微信</a
                    >
                    打开【客户联系】 -选择【客户】 -展开右侧【API】 -Secret。
                    将客户秘钥Secret重新复制更新到下方输入框中

                  </p>
                  <div class="copyButton">
                    <el-form-item
                        label="客户密钥Secret"
                        prop="cus_secret"
                        label-width="17.0rem"
                    >
                      <el-input
                          clearable
                          v-model="ruleForm.cus_secret"
                          placeholder="请输入客户秘钥Secret"
                          id="kehu"
                      ></el-input>
                    </el-form-item>
                    <span class="copy" @click="copyValue('kehu')">复制</span></div>
                </div>
              </div>
              <el-button class="nextStep" type="primary" @click="nextStep('ruleForm')">下一步</el-button>
            </div>
            <!-- <div class="showAllInformation">
              <p class="title">配置通讯录同步密钥Secret</p>
              <p>
                进入
                <a
                  class="help-link"
                  href="https://work.weixin.qq.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #f96460"
                  >企业微信</a
                >
                打开【管理工具】 -选择【通讯录同步】 -点击Secret查看。
                将通讯录密钥Secret重新复制更新到下方输入框中
                <span
                  style="color: #f96460; cursor: pointer"
                  @click="onSubmit9 = true"
                  >配置教程</span
                >
              </p>
            </div>
            <el-form-item
              label="通讯录密钥Secret"
              prop="circle_secret"
              label-width="17.0rem"
            >
              <el-input
                clearable
                v-model="ruleForm.circle_secret"
                placeholder="请输入通讯录密钥Secret"
              ></el-input>
            </el-form-item> -->

          </el-form>
        </div>
      </div>
    </div>
    <div :class="ines == true ? 'gain' : 'no_gain'">
      <div>
        <div class="showHeader">
          <p class="archiveTitle">存档参数配置</p>
          <div class="inforText">
            <p class="">还差一步就可以开始体验会话存档啦</p>
            <p class="">
              为保证正常体验会话内容存档全部功能，请先完成以下配置后使用，在配置过程中遇到问题可以联系客服400-113-0200
            </p>
          </div>
        </div>
        <div class="fuwu-peizhi">
          <div>
          <p class="title">接收事件服务器配置</p>
        </div>
          <div style="padding: 2.0rem 2.0rem 6.6rem;background-color:#fff;">
            <div class="fuwuqipeizhi">
              <p class="nobn">
                进入
                <a
                    class="help-link"
                    href="https://work.weixin.qq.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style="color: #317AF8"
                >企业微信</a
                >
              </p>
              <ul class="bboss">
                <li>
                  <p>
                    第一步:将下方URL复制并添加到企业微信接收事件服务器编辑/设置-URL中
                  </p>
                </li>
                <li>
                  <p>
                    第二步:点击随机获取按钮，将获取Token复制并填写到下方Token输入框中。如果后续Token有更新，请重新进行复制，确保系统中配置中的Token与企业微信中Token保持一
                    致
                  </p>
                </li>
                <li>
                  <p>第三步:点击随机获取按钮，将获取</p>
                </li>
                <li style="color: #317AF8;margin-bottom: 2.0rem">
                  <p>
                    第四步:必须先点击下方的[配置完成，开启使用]按钮，然后回到企业微信点击[保存]按钮，企业微信中会出现保存成功的提示
                  </p>
                </li>
              </ul>
            </div>
            <div class="nnn">
              <el-form
                  :model="ruleFormn"
                  :rules="rules"
                  ref="ruleFormn"
                  label-width="14.0rem"
                  label-position="right"
                  class="demo-ruleForm"
              >
                <div class="copyButton1">
                <el-form-item label="url">
                  <el-input
                      clearable
                      id="serverIpvv"
                      :readonly="true"
                      v-model="ruleFormn.url"
                  ></el-input>
                </el-form-item>
                <span class="nextcopy" @click="copyValue('serverIpvv')">复制</span>
                </div>
                <div class="copyButton1">
                <el-form-item label="Token" prop="token">
                  <el-input
                      clearable
                      id="serverToken"
                      :readonly="true"
                      v-model="ruleForm.token"
                  ></el-input>
                </el-form-item>
                <span class="nextcopy" @click="copyValue('serverToken')">复制</span>
                </div>
                <div class="copyButton1">
                <el-form-item label="EncodingAESKey" prop="encodingAesKey">
                  <el-input
                      clearable
                      id="serverKey"
                      :readonly="true"
                      v-model="ruleForm.encodingAesKey"
                  ></el-input>
                </el-form-item>
                <span class="nextcopy" @click="copyValue('serverKey')">复制</span>
                </div>
              </el-form>
            </div>
            <div class="footer">
              <el-button type="primary" @click="submitForm('ruleFormn')"
              >配置完成，开启使用
              </el-button
              >
              <el-button class="goback" @click="resetForm()">返回上一步配置</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="配置教程" center :visible.sync="onSubmit1" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/1.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit1 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit1 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit2" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/2.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit2 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit2 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit3" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/3.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit3 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit3 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit4" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/4.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit4 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit4 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit5" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/5.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit5 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit5 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit6" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/6.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit6 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit6 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit7" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/7.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit7 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit7 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit8" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/8.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit8 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit8 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit9" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/62c142c7e4172c9a4a19e1eba1d1cd4.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit9 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit9 = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="onSubmit10" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/wxServer.jpg" alt/>
        <img src="../../assets/custId.png" alt/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit10 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit10 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import StylePanel from "@/common/pageDesign/panel/stylePanel.vue";

export default {
  components: {StylePanel},
  inject: ["reload"],
  data() {
    return {
      ipdz: "",
      onSubmit1: false,
      onSubmit2: false,
      onSubmit3: false,
      onSubmit4: false,
      onSubmit5: false,
      onSubmit6: false,
      onSubmit7: false,
      onSubmit8: false,
      onSubmit9: false,
      onSubmit10: false,
      username: {},
      token: "",
      title: {},
      textarea: "",
      privateAddress: "",
      encodingAesKey: "",
      // 私钥地址
      privatekey_url: "",
      // 公钥地址
      publickey_url: "",
      // token: "",
      placeholderText: "当前内容不可见",
      publicContent: "",
      baseURL: this.axios.defaults.baseURL,
      account_id: Number,
      phone: Number,
      privateContent: "",
      tooken: "",

      ruleForm: {
        companyName: "",
        account_corpid_ww: "",
        version: "",
        sessionKey: "",
        cus_secret: "",
        privateAddress: "",
        encodingAesKey: "806Va2HBMsSxVi8mhqHBw9amMVPHJ5YrYlfBJdgcau6",
        token: "",
        circle_secret: "",
        service_secret: "",
      },
      ruleFormn: {
        url: "",
      },
      shouquan: "",
      imgUrl: "",
      authority: "",
      bianll: false,
      ines: true,
      jiaoyan: "",
      chongg: "",
      shibai: "",
      auth_code: "",
      rules: {
        companyName: [
          {required: true, message: "请输入企业全称", trigger: "blur"},
          {
            min: 2,
            max: 35,
            message: "长度在 2 到 35 个字符",
            trigger: "blur",
          },
        ],
        account_corpid_ww: [
          {required: true, message: "请输入企业ID", trigger: "blur"},
        ],
        cus_secret: [
          {
            required: true,
            message: "请输入客户秘钥Secret",
            trigger: "blur",
          },
        ],
        circle_secret: [
          {
            required: true,
            message: "请输入通讯录Secret",
            trigger: "blur",
          },
        ],
      },
      srcList: []
    };
  },
  methods: {
    resetForm() {
      this.bianll = false;
      this.ines = true;
    },
    // 配置完成开启会话存档
    submitForm() {
      this.setCompanyInformations();
    },
    // 更新公钥
    updatePublicKey() {
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/getKey`,
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: qs.stringify({
          account_id: this.account_id,
          phone: this.phone,
          usertoken: this.token,
        }),
      })
          .then((res) => {
            this.publicContent = res.data.data.pubKey;
            this.privatekey_url = res.data.data.privkey;
          })
          .catch((err) => {
          });
    },
    // 复制功能的实现
    copyValue(value) {
      let theValue = document.getElementById(value);
      theValue.select();
      document.execCommand("Copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    eee() {
      this.bianll = true;
      this.ines = false;
    },
    nextStep(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleFormn.url =
              "https://api.weijub.com/home/Callback/notify?corpid=" +
              this.ruleForm.companyId;
          this.ruleForm.token = "znLGYqkFOCl1WN";
          this.ruleForm.encodingAesKey =
              "806Va2HBMsSxVi8mhqHBw9amMVPHJ5YrYlfBJdgcau6";
          this.bianll = true;
          this.ines = false;
        } else {
          return false;
        }
      });
    },
    // 发送请求设置企业信息
    setCompanyInformations() {
      // 设置企业信息时获取用户输入的所有的企业信息
      // 企业全称
      this.ruleForm.companyName = this.ruleForm.companyName.trim();
      // 企业id
      this.ruleForm.account_corpid_ww = this.ruleForm.account_corpid_ww.trim();
      // IP地址1
      this.ruleForm.companyAdress = this.ruleForm.companyAdress.trim();
      // 公钥版本号
      this.ruleForm.version = this.ruleForm.version;
      // 会话秘钥
      this.ruleForm.sessionKey = this.ruleForm.sessionKey.trim();
      // 客户秘钥
      this.ruleForm.cus_secret = this.ruleForm.cus_secret.trim();
      // 外部联系人秘钥
      // this.ruleForm.relativeKey = this.ruleForm.relativeKey.trim();

      this.ruleForm.circle_secret = this.ruleForm.circle_secret.trim();

      this.ruleForm.service_secret = this.ruleForm.service_secret;
      // aes_key值
      this.ruleForm.encodingAesKey = this.ruleForm.encodingAesKey.trim();
      // token
      this.ruleForm.token = this.ruleForm.token.trim();
      // 发送请求，设置企业信息
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/editAddAccountInfo`,
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: qs.stringify({
          usertoken: this.token,
          account_id: this.account_id,
          account_name: this.ruleForm.companyName,
          account_corpid: this.ruleForm.companyId,
          account_corpid_ww: this.ruleForm.account_corpid_ww,
          privkey: this.privatekey_url,
          publickey_ver: this.ruleForm.version,
          secret: this.ruleForm.sessionKey,
          cus_secret: this.ruleForm.cus_secret,
          circle_secret: this.ruleForm.circle_secret,
          service_secret: this.ruleForm.service_secret,
          encodingAesKey: this.ruleForm.encodingAesKey,
          token: this.ruleForm.token,
          pubKey: this.publicContent,
          phone: this.phone,
        }),
      })
          .then((res) => {
            if (res.data.code == 1) {
              this.jiaoyan = res.data.code;
              this.chongg = res.data.msg;
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.reload();
            } else if (res.data.code == 0) {
              this.jiaoyan = res.data.code;
              this.shibai = res.data.msg;
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .catch((err) => {
          });
    },
    // 渲染企业信息
    renderInformation(res) {
      this.ruleForm.companyName = res.account_name;
      this.ruleForm.account_corpid_ww = res.account_corpid_ww;
      this.ruleForm.companyId = res.account_corpid;
      this.ruleForm.version = res.publickey_ver;
      this.ruleForm.companyAdress =
          this.baseURL.split("/")[this.baseURL.split("/").length - 1];
      this.ruleForm.sessionKey = res.secret;
      this.ruleForm.cus_secret = res.cus_secret;
      this.ruleForm.circle_secret = res.circle_secret;
      this.ruleForm.service_secret = res.service_secret;
      this.ruleForm.encodingAesKey = res.encodingAesKey;
      this.ruleForm.token = res.token;
    },
    getQuery(url, name, desc = "order") {
      let strs;
      let index;
      let splitItem;
      if (desc === "order") {
        index = url.indexOf("?");
      } else {
        index = url.lastIndexOf("?");
      }
      if (index !== -1) {
        strs = url.slice(index + 1).split("&");
      }
      for (let k = 0; k < strs.length; k++) {
        splitItem = strs[k].split("=");
        if (splitItem[0] === name) {
          return splitItem[1];
        }
      }
    },
    abcud() {
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/getAccountInfo`,
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: qs.stringify({
          usertoken: this.token,
          account_id: this.account_id,
          phone: this.phone,
        }),
      })
          .then((res) => {
            this.renderInformation(res.data.data);
            this.publicContent = res.data.data.publickey;
            this.boboned();
          })
          .catch((err) => {
          });
    },
    slix() {
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/getAuthCode`,
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: qs.stringify({
          usertoken: this.token,
          auth_code: this.auth_code,
          account_id: this.account_id,
        }),
      })
          .then((res) => {
            this.abcud();
          })
          .catch((err) => {
          });
    },
    boboned() {
      this.axios({
        method: "post",
        url: `${this.baseURL}/home/AccountInfo/getKey`,
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: qs.stringify({
          account_id: this.account_id,
          phone: this.phone,
          usertoken: this.token,
        }),
      })
          .then((res) => {
            this.publicContent = res.data.data.pubKey;
            this.privatekey_url = res.data.data.privkey;
            this.ipdz = res.data.data.serverip;
          })
          .catch((err) => {
          });
    },
  },
  created() {
    // 获取usertoken
    // 页面刷新就请求到数据渲染到页面中
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.token = userinfo.usertoken;
      this.account_id = userinfo.account_id;
      this.phone = userinfo.phone;
    }
    // 获取已经添加的企业信息
    this.axios({
      method: "post",
      url: `${this.baseURL}/home/AccountInfo/getAccountInfo`,
      headers: {"Content-Type": "application/x-www-form-urlencoded"},
      data: qs.stringify({
        usertoken: this.token,
        account_id: this.account_id,
        phone: this.phone,
      }),
    })
        .then((res) => {
          if (res.data.code == 1) {
            this.renderInformation(res.data.data);
            this.ipdz = res.data.data.serverip;
            if (res.data.data.publickey) {
              this.publicContent = res.data.data.publickey;
            } else {
              this.updatePublicKey();
            }
            this.shouquan = res.data.data.if_self;
            this.imgUrl = res.data.data.if_self_image;
            this.srcList = this.srcList.concat(res.data.data.if_self_image)
            this.authority = res.data.data.self_prive_name;
          } else if (res.data.code == 0) {
            const url = location.href;
            this.auth_code = this.getQuery(url, "auth_code", "order");
            this.slix();
          }
        })
        .catch((err) => {
        });
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.shouye {
  width: 100%;
  //overflow: hidden;
  overflow-y: auto;
}
.shouye::-webkit-scrollbar { width: 0 !important }
.shouye { -ms-overflow-style: none; }
.showInformation {
  border-radius: 1.0rem;
  padding-bottom: 3.6rem;
  padding-left: 3.0rem;
}

.showHeader {
  background: #FFFFFF;
  border-radius: .4rem;
  padding: 2.0rem;
  margin-bottom: 2.0rem;
}

.onlyOneStep {
  color: #444444;
  font-weight: bold;
  font-size: 2.4rem;
  height: 100%;
}

.detail {
  color: #5c5c5c;
  font-size: 2.0rem;
}

.showContent {
  width: 100%;
  padding-bottom: 5.0rem;
}

.paramsInformation {
  position: relative;
}

.paramsIntroduction {
  width: 57.3%;
}

.archiveTitle {
  font-weight: 600;
  color: #19273c;
  font-size: 2.1rem;
  margin-bottom: 1.6rem;
}

.update {
  width: 9.2rem;
  height: 3.2rem;
  background: #3088db;
  text-align: center;
  line-height: 3.2rem;
  color: #ffffff;
  font-size: 1.6rem;
  border-radius: .4rem;
  position: absolute;
  top: 1.5rem;
  right: -13.0rem;
  cursor: pointer;
}

.nextStep {
  position: absolute;
 bottom: 0;
  right: 0;
  width: 10.0rem;;
  background: #49B372 linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%) !important;
}

.showAllInformation {
  margin: 4.0rem 0 2.0rem 0;
  color: #7b7b7b;
}

.showAllInformation p:nth-child(2) {
  line-height: 3.0rem;
}

.title {
  font-size: 1.8rem;
  font-weight: bold;
}

.gain {
  display: none;
}

.on_gain {
  display: block;
}

.no_gain {
  padding: 0;
  border-radius: 1.0rem;
}

.body_aun {
  width: 90%;
  height: 75.0rem;
  background-color: #ffffff;
  padding: 3.0rem;
  margin: 2.0rem auto;
}

.body_aun > div {
  width: 80%;
  height: 90%;
  margin: 3.0rem auto;
  border: .1rem solid rgb(229, 229, 229);
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}

.noneboy {
  width: 100%;
  background-color: rgb(237, 245, 252);
  margin-top: 2.0rem;
  padding: 2.0rem;
}

.noneboy > h3 {
  margin-top: 2.0rem;
}

.bboss {
  margin-top: 1.5rem;
}

.bboss > li {
  margin-top: 1.5rem;
}

.nnn {
  width: 90%;
}

.title {
  font-size: 2.1rem;
  font-weight: 500;
  color: #333333;
}

.inforText {
  font-weight: 400;
  color: #888888;
  height: 4.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 1.4rem;
}

.el-form-item__label {
  font-weight: 600;
  color: #333;
}

.el-form-item {
  width: 55%;
}

.update-btn {
  display: inline-flex;
  margin-left: 2.0rem;
}

.el-textarea {
  display: inline-flex;
  height: 14.1rem !important;
  width: 46.3rem !important;
}


.messageEncryption {
  width: 41.5%;
}

.fuwu-peizhi {
  color: #888;
  line-height: 1.5;
}

.footer {
  margin-top: 6.0rem;
}

.show-demo-ruleForm {
  display: flex;
  justify-content: space-between;
}

.show-demo-ruleForm div div {
  background-color: #fff;
}

.mytitle {
  height: 6.9rem;
  padding: 0 2.0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #F6FFFA !important;

  span {
    width: 8.0rem;
    height: 4.0rem;
    line-height: 4.0rem;
    text-align: center;
    font-size: 1.4rem;
    color: #49B372;
    border-radius: .8rem;
    border: .1rem solid #49B372;
    cursor: pointer
  }
}

.mycontent {
  padding: 2.0rem;
  color: #666666;
.inwx{
  line-height: 2.2rem;
}
  ul {
    display: flex;

    .jiantou {
      width: 3.1rem;
      height: 1.6rem;
      margin: 1.0rem 1.5rem 0;
    }

    li {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 3.5rem;
        height: 3.5rem;
        margin-bottom: 1.7rem;
      }

      p {
        text-align: center;
      }
    }
  }

  p {
    font-size: 1.6rem;
    margin-bottom: 2.0rem;
  }

  .el-form-item {
    margin-bottom: 0;
    width: 83%;
  }


}

.copyButton {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.copyButton1 {
  display: flex;
}
.copy,.nextcopy {
  display: inline-block;
  width: 8.0rem;
  height: 4.0rem;
  font-size: 1.4rem;
  line-height: 4.0rem;
  background: #49B372;
  text-align: center;
  color: #fff;
  border-radius: .8rem;
}
.fuwu-peizhi{
  .title{
    height: 6.9rem;
    line-height: 6.9rem;
    padding: 0 2.0rem;
    background-color: #F6FFFA !important;
  }
  .el-form-item {
    margin-bottom: 2.0rem;
  }
}
.goback{
  background: #F6FFFA;
  border-radius: .8rem;
  color: #49B372;
  border: .1rem solid #49B372;
}
.nextcopy{
  margin-left: 2.0rem;
}
.footer .el-button:nth-of-type(2):hover{
  background: #F6FFFA;
  color: #49B372;
  border: .1rem solid #49B372;
}
.fuwuqipeizhi{
  font-size: 1.6rem;
}
::v-deep .el-form-item__label{
  font-size: 1.6rem ;

}
.el-dialog img{
  width: 100%;
}
::v-deep .el-input__inner{
  font-size: 1.6rem ;
  color: #999999;
  padding: 0 1rem;
}
</style>
